import { defaultConfig } from '../../../utils/remoteConfigs'

const configs = {
	upsell_price: defaultConfig.upsell_price,
	initial_price: defaultConfig.initial_price,
}
export default configs
